export const RECORD_SOURCES = {
  THIS_RECORD: 'this_record',
  RELATED_OBJECT_FIELD: 'related_object_field',
  AUTOMATION_VARIABLE: 'automation_variable',
} as const;

export const ACTION_TYPES = {
  PAUSE: 'pause',
  CANCEL: 'cancel',
} as const;
